<div class="row" style="padding:5px;">
  <dx-data-grid id="ScoreCardGroupScoreAnalysis" class="dashboard-grid"
                [dataSource]="__oFAScoreCardGroupScoreAnalysis"
                [allowColumnReordering]="true"
                [allowColumnResizing]="true"
                columnResizingMode="widget"
                [columnMinWidth]="75"
                [columnAutoWidth]="true"
                [showColumnLines]="true"
                [showRowLines]="true"
                [showBorders]="true"
                [rowAlternationEnabled]="false"
                [hoverStateEnabled]="true"
                keyExpr="Id"
                style="min-width:100%;">
    <dxo-paging [pageSize]="1000"></dxo-paging>
    <dxo-pager [visible]="__oFAScoreCardGroupScoreAnalysis.length > 0"
               [showPageSizeSelector]="__oFAScoreCardGroupScoreAnalysis.length > 0"
               [allowedPageSizes]="[10, 100 ,1000]"
               [visible]="true"
               [showNavigationButtons]="true"
               [showInfo]="true"
               [displayMode]="'full'">
    </dxo-pager>
    <dxo-editing mode="cell"
                 [allowAdding]="false"
                 [allowUpdating]="true"
                 [allowDeleting]="false">
    </dxo-editing>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-filter-row [visible]="true"
                    applyFilter="auto"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>


    <dxi-column [allowEditing]="false" dataField="ScoreCardGroup" [width]="250" caption="Score Card Group">  </dxi-column>
    <dxi-column [allowEditing]="false" cellTemplate="gridCellTemplateScore" [width]="200" caption="Score"></dxi-column>
    <dxi-column [allowEditing]="false" dataField="Rating" [width]="200" caption="Rating">  </dxi-column>
    <dxi-column cellTemplate="gridCellTemplateWeightGuage" [width]="250" caption="Weight Gauge (%)"></dxi-column>
    <dxi-column [allowEditing]="false" cellTemplate="gridCellTemplateWeightedScore" [width]="200" caption="Weighted Score"></dxi-column>


    <div *dxTemplate="let Info of 'gridCellTemplateWeightGuage'">
      <div class="col-md-10" style="padding:0px;">
        <dx-slider [min]="0"
                   [max]="100"
                   [(value)]="Info.data.WeightGuage"
                   [rtlEnabled]="false"
                   (onValueChanged)="SliderValueChanged(Info.data.Id)"
                   [disabled]="__bReadOnly === 1">
        </dx-slider>
      </div>
      <div class="col-md-2" style="padding:3px;text-align:center;">
        <span>{{Info.data.WeightGuage}}</span>
      </div>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateScore'">
      <dx-number-box [step]="0" format="#,##0.00" [(value)]="Info.data.Score" [disabled]="true" style="text-align:right;"></dx-number-box>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateWeightedScore'">
      <dx-number-box [step]="0" format="#,##0.00" [(value)]="Info.data.WeightedScore" [disabled]="true" style="text-align:right;"></dx-number-box>
    </div>



  </dx-data-grid>
</div>
<div class="row" style="padding:5px;">
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6" style="text-align:left;"><span>Total Weight Gauge</span></div>
      <div class="col-md-6"><span class="dx-field-label" [ngStyle]="{'color':__iTotalWeightGauge > 100 ? 'red':'black'}">{{__iTotalWeightGauge}}%</span></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-11"><span class="dx-field-label" [ngStyle]="{'visibility':__iTotalWeightGauge > 100 ? 'visible':'hidden'}"  style="color:red;">Total weight gauge should be equal and less than 100%</span></div>
      <div class="col-md-1"><span class="dx-field-label"></span></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6"><span class="dx-field-label"></span></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
</div>

<div class="row" style="padding:5px;">
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6" style="text-align:left;"><span class="dx-field-label">Weighted Financial Rating</span></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6"><dx-text-box id="txtFinancialRating" [disabled]="true" [(value)]="__sWeightedFinancialRating"></dx-text-box></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6"><dx-number-box [step]="0" format="#,##0.00" [(value)]="__iWeightedFinancialScore" [disabled]="true" style="text-align:right;"></dx-number-box></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
</div>

<div class="row" style="padding:5px;">
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6" style="text-align:left;"><span class="dx-field-label">Qualitative Rating</span></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6"><dx-text-box id="txtQualitativeRating" [disabled]="true" [(value)]="__sWeightedQualitativeRating"></dx-text-box></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6"><dx-number-box [step]="0" format="#,##0.00" [(value)]="__iWeightedQualitativeScore" [disabled]="true" style="text-align:right;"></dx-number-box></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
  </div>


<div class="row" style="padding:5px;">
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6" style="text-align:left;"><span class="dx-field-label">Intrinsic Rating</span></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6"><dx-text-box id="txtIntrinsicRating" [disabled]="true" [(value)]="__sWeightedIntrinsicRating"></dx-text-box></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row text-center">
      <div class="col-md-6"><dx-number-box [step]="0" format="#,##0.00" [(value)]="__iWeightedIntrinsicScore" [disabled]="true" style="text-align:right;"></dx-number-box></div>
      <div class="col-md-6"><span class="dx-field-label"></span></div>
    </div>
  </div>
</div>

<dx-load-panel id="pnlLoad"
               shadingColor="rgba(0,0,0,0.4)"
               [position]="{ at: 'center' }"
               [(visible)]="__bIsLoadingVisible"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [hideOnOutsideClick]="false"
               [height]="75"
               [width]="150"
               message="Please Wait...">
</dx-load-panel>
